import { useTranslation } from 'react-i18next'

import { Divider } from '../../../Divider'
import Text from '../../../Text'
import { ProfileContactsWidgetLabel } from '../ProfileContactsWidgetLabel'

import * as styles from './ProfileContactsWidgetListCellNoValue.module.css'

function ProfileContactsWidgetListCellNoValue({ typeConfig }) {
  const { t } = useTranslation()

  return (
    <div className={styles.cell}>
      <div className={styles.content}>
        <ProfileContactsWidgetLabel
          className={styles.label}
          infoTooltipKey={typeConfig.infoTooltipKey}
          label={t(typeConfig.labelKey)}
        />
        <div className={styles.row}>
          <Text disabled isSecondary>
            {t(typeConfig.noValueTextKey)}
          </Text>
        </div>
      </div>

      <Divider className={styles.divider} />
    </div>
  )
}

export default ProfileContactsWidgetListCellNoValue
